import React, { useState } from "react";
import { EnvironmentOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import { canOpenLocationInGoogleMaps, openLocationInGoogleMaps, parseLocationMessage } from "../locationUtils";
import { renderTextWithLinks } from "./CustomLinkPreview";

const LocationMessage = ({ message }) => {
  const [hovered, setHovered] = useState(false);
  const location = parseLocationMessage(message);
  const canOpenMaps = canOpenLocationInGoogleMaps(message);

  const handleOpenMaps = () => {
    if (!canOpenMaps) {
      return;
    }
    openLocationInGoogleMaps(message);
  };

  return (
    <div style={{ maxWidth: 280, minWidth: 200 }}>
      <button
        type="button"
        onClick={handleOpenMaps}
        title={canOpenMaps ? "Open in Google Maps" : undefined}
        onMouseEnter={() => canOpenMaps && setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onFocus={() => canOpenMaps && setHovered(true)}
        onBlur={() => setHovered(false)}
        style={{
          position: "relative",
          display: "block",
          width: "100%",
          padding: 0,
          border: "none",
          background: "transparent",
          cursor: canOpenMaps ? "pointer" : "default",
          borderRadius: 8,
          overflow: "hidden",
        }}
      >
        <img
          src="/img/location.png"
          alt="location"
          loading="lazy"
          style={{
            width: "100%",
            aspectRatio: "16 / 9",
            objectFit: "cover",
            borderRadius: 8,
            display: "block",
          }}
        />
        {canOpenMaps ? (
          <div
            aria-hidden
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
              background: "rgba(11, 20, 26, 0.52)",
              color: "#fff",
              opacity: hovered ? 1 : 0,
              transition: "opacity 0.2s ease",
              borderRadius: 8,
              zIndex: 2,
              pointerEvents: "none",
            }}
          >
            <EnvironmentOutlined style={{ fontSize: 16 }} />
            <span style={{ fontSize: 13, fontWeight: 600, lineHeight: 1.2 }}>
              Open in Google Maps
            </span>
          </div>
        ) : null}
        <Tag
          icon={<EnvironmentOutlined />}
          color="green-inverse"
          style={{
            position: "absolute",
            right: 8,
            bottom: 8,
            margin: 0,
            fontSize: "11px",
            lineHeight: "16px",
            borderRadius: 4,
            zIndex: 3,
            pointerEvents: "none",
          }}
        >
          Location
        </Tag>
      </button>
      {(message?.text || location?.label) ? (
        <div style={{ marginTop: 8, fontSize: 13, lineHeight: 1.4, color: "#111b21" }}>
          {renderTextWithLinks(location?.label || message.text)}
        </div>
      ) : null}
    </div>
  );
};

export default LocationMessage;
